<template>
  <v-dialog v-model="localVisible" max-width="600" persistent scrollable>
    <v-card class="rounded-xl elevation-10" style="background-color: #ffffff;">
      <!-- Minimalist Header -->
      <v-card-title class="pt-8 pb-4 px-sm-8 px-5 d-flex justify-space-between align-center">
        <span class="text-h5 font-weight-bold" style="color: #030a1a; font-family: 'Roboto Condensed', sans-serif; letter-spacing: -0.5px;">
          Bem-vindo à Veri Salvatori
        </span>
        <v-btn icon @click="close" color="grey darken-1" class="ml-auto" variant="plain">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      
      <!-- Body -->
      <v-card-text class="px-sm-8 px-5 pb-6" style="color: #515154; max-height: 65vh; font-size: 1.05rem;">
        <p class="mb-6" style="line-height: 1.6;">
          Seu acesso à plataforma <strong>Veri Salvatori</strong> está liberado. A plataforma reúne recursos essenciais para você praticar, revisar e acompanhar sua evolução de forma estratégica.
        </p>

        <!-- Subtle info box -->
        <div class="mb-6 d-flex align-start pa-4 rounded-lg" style="background-color: #f4f6fa; border: 1px solid #e2e8f0;">
          <v-icon color="#315fd8" class="mr-3 mt-1" small>mdi-pin-outline</v-icon>
          <span style="font-size: 0.95rem; line-height: 1.5; color: #0d172e;">
            Todos os recursos ficam disponíveis no menu localizado no lado esquerdo da tela.
          </span>
        </div>

        <v-list class="bg-transparent pa-0">
          <!-- Simulados -->
          <v-list-item class="px-0 mb-5 align-start">
            <v-icon color="#315fd8" class="mr-4 mt-1" size="26">mdi-file-document-edit-outline</v-icon>
            <v-list-item-content class="pt-0">
              <v-list-item-title class="font-weight-medium mb-1" style="color: #1d1d1f; font-size: 1.1rem;">Simulados</v-list-item-title>
              <div class="text-wrap" style="color: #515154; line-height: 1.5; font-size: 0.95rem;">
                Utilize os simulados para treinar como na prova real e testar seus conhecimentos.
              </div>
            </v-list-item-content>
          </v-list-item>

          <!-- Do jeito da prova real -->
          <v-list-item class="px-0 mb-5 align-start">
            <v-icon color="#315fd8" class="mr-4 mt-1" size="26">mdi-timer-outline</v-icon>
            <v-list-item-content class="pt-0">
              <v-list-item-title class="font-weight-medium mb-1" style="color: #1d1d1f; font-size: 1.1rem;">Do jeito da prova real</v-list-item-title>
              <div class="text-wrap" style="color: #515154; line-height: 1.5; font-size: 0.95rem;">
                Sugerimos realizar as 90 questões seguidas, sem interrupções, sem consulta e sem celular, treinando concentração, foco e resistência à fadiga.
              </div>
            </v-list-item-content>
          </v-list-item>

          <!-- Precisa pausar -->
          <v-list-item class="px-0 mb-5 align-start">
            <v-icon color="#315fd8" class="mr-4 mt-1" size="26">mdi-pause-circle-outline</v-icon>
            <v-list-item-content class="pt-0">
              <v-list-item-title class="font-weight-medium mb-1" style="color: #1d1d1f; font-size: 1.1rem;">Precisa pausar? Sem problema!</v-list-item-title>
              <div class="text-wrap" style="color: #515154; line-height: 1.5; font-size: 0.95rem;">
                Você pode realizar o simulado de forma fracionada. O sistema salva automaticamente seu progresso a cada 5 questões, permitindo que você retome de onde parou.
              </div>
            </v-list-item-content>
          </v-list-item>

          <!-- Confira seus resultados (Simulados) -->
          <v-list-item class="px-0 mb-5 align-start">
            <v-icon color="#315fd8" class="mr-4 mt-1" size="26">mdi-poll</v-icon>
            <v-list-item-content class="pt-0">
              <v-list-item-title class="font-weight-medium mb-1" style="color: #1d1d1f; font-size: 1.1rem;">Confira seus resultados</v-list-item-title>
              <div class="text-wrap" style="color: #515154; line-height: 1.5; font-size: 0.95rem;">
                Após realizar o simulado, acesse <strong>Gabarito Simulados → Meus Gabaritos</strong> para conferir suas respostas. Em <strong>Métricas Simulados</strong>, acompanhe sua taxa de acertos e desempenho.
              </div>
            </v-list-item-content>
          </v-list-item>

          <!-- Treinar Questões -->
          <v-list-item class="px-0 mb-5 align-start">
            <v-icon color="#315fd8" class="mr-4 mt-1" size="26">mdi-head-question-outline</v-icon>
            <v-list-item-content class="pt-0">
              <v-list-item-title class="font-weight-medium mb-1" style="color: #1d1d1f; font-size: 1.1rem;">Treinar Questões</v-list-item-title>
              <div class="text-wrap" style="color: #515154; line-height: 1.5; font-size: 0.95rem;">
                Monte seu próprio treino. Escolha a quantidade, temas e subtemas. Selecione o modo Tutor ou opte por refazer apenas questões que já errou, reforçando os pontos de maior dificuldade.
              </div>
            </v-list-item-content>
          </v-list-item>

          <!-- Flashcards -->
          <v-list-item class="px-0 mb-5 align-start">
            <v-icon color="#315fd8" class="mr-4 mt-1" size="26">mdi-cards-outline</v-icon>
            <v-list-item-content class="pt-0">
              <v-list-item-title class="font-weight-medium mb-1" style="color: #1d1d1f; font-size: 1.1rem;">Flashcards</v-list-item-title>
              <div class="text-wrap" style="color: #515154; line-height: 1.5; font-size: 0.95rem;">
                Faça revisões rápidas e reforce a fixação dos conteúdos. Os decks são organizados por semanas e temas, para seguir uma sequência de estudos ou focar no que deseja revisar.
              </div>
            </v-list-item-content>
          </v-list-item>

          <!-- Acompanhe seu desempenho (Geral) -->
          <v-list-item class="px-0 mb-4 align-start">
            <v-icon color="#315fd8" class="mr-4 mt-1" size="26">mdi-chart-line</v-icon>
            <v-list-item-content class="pt-0">
              <v-list-item-title class="font-weight-medium mb-1" style="color: #1d1d1f; font-size: 1.1rem;">Acompanhe seu desempenho</v-list-item-title>
              <div class="text-wrap" style="color: #515154; line-height: 1.5; font-size: 0.95rem;">
                Consulte suas métricas de questões e simulados para identificar seu desempenho geral e os pontos que exigem mais atenção.
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        
        <!-- Subtle info box -->
        <div class="mt-4 mb-2 d-flex align-start pa-4 rounded-lg" style="background-color: #f4f6fa; border: 1px solid #e2e8f0;">
          <v-icon color="#315fd8" class="mr-3 mt-1" small>mdi-lightbulb-outline</v-icon>
          <span style="font-size: 0.95rem; line-height: 1.5; color: #0d172e;">
            Explore o menu à esquerda e aproveite todos os recursos disponíveis no seu acesso.
          </span>
        </div>
      </v-card-text>

      <!-- Minimalist Footer -->
      <v-card-actions class="px-sm-8 px-5 pb-8 pt-4 d-flex justify-end">
        <v-btn
          class="px-8 rounded-xl font-weight-bold"
          style="background: linear-gradient(135deg, #05122e 0%, #315fd8 100%); color: #ffffff; text-transform: none; letter-spacing: 0.02em; font-size: 1rem; height: 48px;"
          elevation="2"
          @click="close"
        >
          Começar a explorar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'FreemiumWelcomeDialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localVisible: this.dialogVisible
    }
  },
  watch: {
    dialogVisible(val) {
      this.localVisible = val;
    },
    localVisible(val) {
      if (!val) {
        this.$emit('close');
      }
    }
  },
  methods: {
    close() {
      this.localVisible = false;
    }
  }
}
</script>

<style scoped>
/* Ajustes para remover efeitos padrões e garantir um look minimalista */
.v-list-item::before {
  display: none !important;
}
.v-list-item:hover {
  background-color: transparent !important;
}
</style>
